import type { ReactNode } from 'react';

import type * as api from '@gitbook/api-client';
import { Icon } from '@gitbook/spine-icons';
import type { OverlayTriggerState } from '@gitbook/spine-react';
import {
    Button,
    Description,
    EmptyState,
    EmptyStateActions,
    EmptyStateIcon,
    Heading,
} from '@gitbook/spine-react';

import { createDocumentationURL } from '../../../utils';
import { SpaceCreateButton } from './SpaceCreateButton';

/**
 * Empty state to be displayed when no spaces are found.
 */
export function SpaceEmptyState(props: {
    createSpaceDialogTrigger: OverlayTriggerState;
    organization: api.Organization;
    description: ReactNode;
    className?: string;
}) {
    const { createSpaceDialogTrigger, organization, className, description } = props;
    return (
        <EmptyState className={className}>
            <EmptyStateIcon>
                <Icon.Space />
            </EmptyStateIcon>
            <Heading>No spaces found</Heading>
            <Description>{description}</Description>
            <EmptyStateActions>
                <SpaceCreateButton organization={organization} trigger={createSpaceDialogTrigger} />
                <Button
                    label="Learn more"
                    kind="secondary"
                    leadingIcon={Icon.ExternalLink}
                    href={createDocumentationURL('creating-content/content-structure/space')}
                    target="_blank"
                />
            </EmptyStateActions>
        </EmptyState>
    );
}
